// src/Modules/InstallationChecklist/installationChecklistTypes.ts

// --- 1. ENUMS ---

export enum ChecklistAnswerType {
  TEXT = "TEXT",
  LONG_TEXT = "LONG_TEXT",
  YES_NO = "YES_NO",
  FILE_UPLOAD = "FILE_UPLOAD",
}

export enum ConditionalAction {
  TEXT = "TEXT",
  LONG_TEXT = "LONG_TEXT",
  FILE_UPLOAD = "FILE_UPLOAD",
  N_A = "N/A", // Represents "No further action required"
}

// --- 2. INTERFACES ---

export interface ChecklistConditionalConfig {
  if_yes: ConditionalAction;
  if_no: ConditionalAction;
}

export interface ChecklistQuestion {
  _id: string; // MongoDB ID
  question: string;
  answer_type: ChecklistAnswerType;
  order: number;

  // Only present/relevant if answer_type === YES_NO
  conditional_config?: ChecklistConditionalConfig;
}

// --- 3. LABELS (Human Readable) ---

export const AnswerTypeLabels: Record<ChecklistAnswerType, string> = {
  [ChecklistAnswerType.TEXT]: "Text",
  [ChecklistAnswerType.LONG_TEXT]: "Long Text",
  [ChecklistAnswerType.YES_NO]: "Yes / No",
  [ChecklistAnswerType.FILE_UPLOAD]: "File Upload",
};

export const ConditionalActionLabels: Record<ConditionalAction, string> = {
  [ConditionalAction.TEXT]: "Text",
  [ConditionalAction.LONG_TEXT]: "Long Text",
  [ConditionalAction.FILE_UPLOAD]: "File Upload",
  [ConditionalAction.N_A]: "N/A",
};

// --- 4. HELPERS (For Select Options) ---

/**
 * Generates options for the Main Answer Type Dropdown
 */
export const getAnswerTypeOptions = () => {
  return Object.values(ChecklistAnswerType).map((value) => ({
    label: AnswerTypeLabels[value],
    value: value,
  }));
};

/**
 * Generates options for the Conditional Action Dropdowns (If Yes / If No)
 */
export const getConditionalActionOptions = () => {
  return Object.values(ConditionalAction).map((value) => ({
    label: ConditionalActionLabels[value],
    value: value,
  }));
};
